//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import uniRate from "@/components/uni-rate/uni-rate.vue"
import bookList from './book.vue'
// import formTitle from '@/components/form-title/index.vue'
import moreContent from '@/components/more-content/index.vue'
import uniPopup from "@/components/uni-popup/uni-popup.vue"
import uniNumberBox from "@/components/uni-number-box/uni-number-box.vue"
import commentList from '@/components/commentList/index.vue'
import collect from '@/components/collect/index.vue'
import uniIcons from "@/components/uni-icon/uni-icon.vue"
var view, view2, view3, top1, top2, top3
export default {
  data() {
    return {
      id: '',
      imgList: [],
      indicatorDots: true,
      indicatorColor: 'rgba(255, 255, 255, .9)',
      autoplay: true,
      interval: 2000,
      duration: 500,
      reference: 0,
      current: 1, //当前所在滑块
      currentLength: 0, //图片总数
      detail: {
        skus: [
        ]
      },
      collectInfo: {
        collectionType: '20',
        productGroupType: '1004',
        collectionId: ''
      },
      skuIndex: 0,
      scrollTop: 0,
      intoView: '',
      isAnimating: false,
      isWeixin: true,
      isTop: false,
      isPay: false,
      skusShow: false,
      navBarList: [
        { id: 'div1', name: '商品详情' },
        { id: 'div2', name: '购买须知' }
      ],
      navName: 'div1',
      goods: {
        title: '',
        picture: '',
        stepNum: 1,
        stock: 99,
        skuId: '',
        salePrice: 0
      },
      commentObj: {
        total: 0,
        starLevel: 5
      }
    }
  },
  onReady() {
    const query = uni.createSelectorQuery().in(this);
    view = query.select("#div1");
    view2 = query.select("#div2");
  },
  onLoad(event) { 
    this.collectInfo.collectionId = this.id = event.id





    this.getDetail()
    // this.queryCommentList()
  },
  components: {
    uniRate,
    bookList,
    moreContent,
    // formTitle,
    uniPopup,
    uniNumberBox,
    commentList,
    collect,
    uniIcons
  },
  methods: {
    //顶部轮播图当前图片页数
    changeImg(event) {
      this.current = event.detail.current + 1
    },
    getDetail() {
      let _this = this
      this.$ajax({
        method: 'POST',
        url: '/weChat/specialtyProduct/queryById',
        data: {
          storeProductId: this.id
        }
      }).then(res => {
        _this.imgList = res.data.photoImages.split(',')
        _this.currentLength = _this.imgList.length
        _this.detail = res.data
        // _this.goods=res.data.storeSkuInfos[0]
        _this.goods.skuId = res.data.storeSkuInfos[0].skuId
        _this.goods.stock = res.data.storeSkuInfos[0].stock
        _this.goods.salePrice = res.data.storeSkuInfos[0].salePrice
        _this.goods.title = res.data.specialtyName
        _this.goods.picture = res.data.coverImageUrl
        let arr = _this.detail.storeSkuInfos.map(element => element.salePrice)
        this.reference = arr.length !== 0 ? Math.min(...arr) : 0
        // _this.goods.stepNum=1
      })
    },
    goShopCar() {
      uni.navigateTo({
        url: '/pages/specialty/shopCar'
      });
    },
    jump() {
      uni.navigateTo({
        url: '/pages/common/images?image=' + this.imgList
      })
    },
    addCart() {
      this.skusShow = true
      this.isPay = false
    },
    buyCart() {
      this.skusShow = true
      this.isPay = true
    },
    submit() {
      if (this.goods.stock == 0) {
        uni.showToast({
          title: '该商品库存不足！',
          icon: 'none'
        })
        return false
      }
      let skuObj = this.detail.storeSkuInfos[this.skuIndex]
      let obj = {
        storeProductId: this.id,
        specialtyName: this.goods.title,
        coverImageUrl: this.goods.picture,
        skuId: skuObj.skuId,
        skuName: skuObj.skuName,
        quantity: this.goods.stepNum,
        skuType: skuObj.skuType,
        singlePrice: skuObj.salePrice
      }
      let _this = this
      if (!this.isPay) {
        this.$ajax({
          method: 'post',
          url: '/weChat/specialtyProduct/addCartInfo',
          data: {
            ...obj,
            // memberId:'599267700576878592'
            memberId: this.$store.state.userInfo.memberId
          }
        }).then(res => {
          uni.showToast({
            title: '已加入购物车',
            icon: 'none'
          })
          _this.skusShow = false
        })
      } else {
        let payInfo = {
          reservationInstructions: this.detail.reservationInstructions,
          cancelType: this.detail.cancelType,
          checkList: [obj],
          total: this.goods.stepNum,
          price: (this.goods.stepNum * this.goods.salePrice).toFixed(2),
          transportCode: this.detail.transportCode,
          transportCodeName: this.detail.transportCodeName
        }
        uni.setStorageSync('payInfo', payInfo)
        uni.navigateTo({
          url: '/pages/specialty/pay'
        })
      }
    },
    skusChange(index) {
      this.skuIndex = index
      this.goods.salePrice = this.detail.storeSkuInfos[index].salePrice
      this.goods.stock = this.detail.storeSkuInfos[index].stock
      this.goods.stepNum = this.detail.storeSkuInfos[index].stock == 0 ? 0 : 1
    },
    bindChange(e) {
      this.goods.stepNum = e
    },
    hide() {
      this.skusShow = false
    },
    scroll(e) {
      let _top = e.detail.scrollTop
      let _this = this
      if (_top >= 340) {
        this.isTop = true
      } else {
        this.isTop = false
      }
      view.boundingClientRect(function (data) {
        top1 = data.top - 50
      }).exec();
      view2.boundingClientRect(function (data) {
        top2 = data.top - 50
      }).exec()
      if (_this.isAnimating) {
        return
      }
      if (top1 < 0 && top2 > 0) {
        this.navName = 'div1'
      } else if (top2 <= 0) {
        this.navName = 'div2'
      }
      this.intoView = ''
    },
    scrollTo(e) {
      this.navName = e
      this.intoView = e
      this.isAnimating = true
      setTimeout(() => {
        this.isAnimating = false
      }, 100)
    },
    // queryCommentList(status) {
    // 	this.$ajax({
    // 		method: 'post',
    // 		url: '/weChat/comment/list',
    // 		data: {
    // 		currentPage: '',
    // 		pageSize: '',
    // 		productId: this.id,
    // 		bodyId: '',
    // 		commentatorId: this.$store.state.userInfo.memberId || ''
    // 		}
    // 	}).then(data => {
    // 		this.$set(this.commentObj, 'data', data)
    // 		this.commentObj.total = data.count
    // 		this.commentObj.starLevel = parseInt(data.dataObj || 0)
    // 	})
    // },
    updateComments(data) {
      this.commentObj.total = data.count
      this.commentObj.starLevel = parseFloat(data.dataObj || 0)
    }
  }
}
